import React from 'react';
import { Task, TaskStatus as TaskStatusEnum } from '@bringg/types';
import { noop as _noop, isFunction as _isFunction } from 'lodash';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import TooltipWrapper from 'components/tooltip/tooltip';
import DateDisplay from 'components/date-display/date-display';
import TaskStatus, { TaskStatusTranslations } from '../../components/task-status/task-status';
import { validateLocation } from '../../services/validation-rules';
import Timezone from 'components/timezone/timezone';

import './task-status-info.scss';

interface TaskStatusProps {
	task: Task;
	dateFormat: string;
	translations: TaskStatusTranslations;
	timezone?: string;
	onClick?: () => void;
	hoverText?: string;
}

const TaskStatusInfo: React.FC<TaskStatusProps> = ({
	task,
	dateFormat,
	translations,
	timezone,
	onClick,
	hoverText
}) => {
	const isClickable = _isFunction(onClick);
	const dateFieldByStatus = {
		[TaskStatusEnum.Created]: task.created_at,
		[TaskStatusEnum.Cancelled]: task.cancelled_at,
		[TaskStatusEnum.Done]: task.ended_time
	};

	return (
		<TooltipWrapper title={hoverText} placement="topLeft">
			<div
				className={classNames('task-status-info-container', { 'status-clickable': isClickable })}
				onClick={isClickable ? onClick : _noop}
			>
				<div className="task-status-header">
					<TaskStatus status={task.status} translations={translations} />
					<div className="task-status-scheduled-time">
						<DateDisplay
							date={dateFieldByStatus[task.status] || task.updated_at}
							format={dateFormat}
							timezone={timezone}
						/>
						{task.status === TaskStatusEnum.Cancelled &&
							validateLocation(task.cancellation_lng, task.cancellation_lat) && (
								<span className="location-link" onClick={onClick}>
									<BringgIcon iconName={BringgFontIcons.Navigation} className="location-link-icon" />
								</span>
							)}
					</div>
				</div>
				{task.status === TaskStatusEnum.Cancelled && (
					<div className="task-status-cancelled">{task.task_cancellation_reason}</div>
				)}
			</div>
			{timezone && <Timezone timezone={timezone} />}
		</TooltipWrapper>
	);
};

export default TaskStatusInfo;
